import React from 'react';
import { FiCheckCircle, FiAlertCircle } from 'react-icons/fi';
import './CreditCheck.css';

const CreditCheck = ({ task }) => {
  // Mock config state
  const isEnabled = true;

  if (!isEnabled) {
    return (
      <div className="credit-check card">
        <div className="card-body text-center">
          <FiAlertCircle className="icon-large warning-text" />
          <h2>Credit Checks Disabled</h2>
          <p>Credit bureau checks are not yet enabled. This feature requires a provider contract and legal approval.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="credit-check card">
      <div className="card-header">
        <h2>Credit Bureau Report (Simulated)</h2>
      </div>
      <div className="card-body">
        <div className="consent-verification">
          <FiCheckCircle className="icon success-text" />
          <span>Valid applicant consent verified for credit check. Data restricted to authorized recipients only.</span>
        </div>

        <div className="credit-summary">
          <div className="summary-box">
            <span className="summary-label">Score Range</span>
            <span className="summary-value success-text">650 - 700 (Good)</span>
          </div>
          <div className="summary-box">
            <span className="summary-label">Active Accounts</span>
            <span className="summary-value">4</span>
          </div>
          <div className="summary-box">
            <span className="summary-label">Adverse Defaults</span>
            <span className="summary-value">0</span>
          </div>
          <div className="summary-box">
            <span className="summary-label">Recent Enquiries</span>
            <span className="summary-value">1</span>
          </div>
        </div>

        <div className="credit-details">
          <p><strong>Provider:</strong> TransUnion SA (Mock API)</p>
          <p><strong>Report Date:</strong> {new Date().toLocaleDateString()}</p>
        </div>

        <div className="dispute-notice">
          <p>If the applicant disputes any credit information, they should contact TransUnion directly at 0861 482 482.</p>
        </div>
      </div>
    </div>
  );
};

export default CreditCheck;
